module.exports = __webpack_public_path__ + "img/gpy8.3a3b3589.png";